import { request } from '../request';

/**
 * 获取数据中心列表
 *
 * @returns
 */
export const fetchPostDataCenterList = () => {
  return request<Api.Customers.DataCenter[]>({
    url: '/developer-platform/api/dataCenter/list',
    method: 'post'
  });
};

/**
 * 获取跨数据中心访问凭证接口
 *
 * @returns
 */
export const fetchPostAuthToken = () => {
  return request<string>({
    url: '/developer-platform/api/auth/token',
    method: 'get'
  });
};

/**
 * 获取静态词条多语言
 *
 * @returns
 */
export const fetchGetLanguageList = () => {
  return request({
    url: '/developer-platform/api/user/language/code/list',
    method: 'get'
  });
};

/**
 * 获取用户租户列表
 * @returns
 */
export const fetchGetUserTenantList = () => {
  return request({
    url: '/developer-platform/api/user/tenantList',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'get'
  });
}

/**
 * 切换用户租户
 * @param id
 * @returns
 */
export const fetchPostChangeUserTenant = (id: string) => {
  return request({
    url: '/developer-platform/api/user/tenantChange',
    method: 'post',
    params: {
      id
    }
  });
}

/**
 *  获取租户菜单
 * @returns
 */
export const fetchPostTenantMenuList = () => {
  return request({
    url: '/developer-platform/api/menu/tenantMenuList',
    method: 'post'
  });
}
